import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { CkeditorConstants } from '../../src/utils';

const {
  class: { WK_KEYWORD_REF },
  helperAttributes: { NUMBERED_CITATION },
  htmlAttributes: { CLASS, ID }
} = CkeditorConstants;

export default class SetCursorPositionCommand extends Plugin {

  constructor(editor) {
    super(editor);
    this.refresh();
  }

  execute({ id }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      this.setSelection(id, item);
    }
  };

  /**
   * @param {*} id id of the citation or keyword reference
   * @param {*} item citation or keyword reference item
   * @param {*} writer writer instance
   */
  setSelection(id, item) {
    const isNumberedCitation = item.name === NUMBERED_CITATION && item.getAttribute(ID) === id;
    const isKeywordRef = item.getAttribute(CLASS) === WK_KEYWORD_REF && item.getAttribute(ID) === id;

    if (isNumberedCitation || isKeywordRef) {
      this.editor.model.change(writer => {
        document.getElementById(`${id}`).click();
        const pos = isNumberedCitation ? writer.createPositionBefore(item) : writer.createPositionAfter(item);
        writer.setSelection(pos);
      });
    }
  }

  refresh() {
  }
}
